module.exports = __webpack_public_path__ + "img/one.23029b12.svg";